import { ConfigButton as ControlMenuV2ConfigButton } from "@/modules/calling/control-menu/v2/buttons/config-button";

export const ConfigButton = () => (
  <ControlMenuV2ConfigButton
    className="w-16"
    isAutoDialSetting={false}
    isMusicSetting={false}
  />
);
